export const QUICK_FILL_TEMPLATE_CREATE = 'QUICK_FILL_TEMPLATE_CREATE'
export const QUICK_FILL_TEMPLATE_CREATE_SUBMIT = 'QUICK_FILL_TEMPLATE_CREATE_SUBMIT'
export const QUICK_FILL_TEMPLATE_CREATE_FAILURE = 'QUICK_FILL_TEMPLATE_CREATE_FAILURE'

export const QUICK_FILL_TEMPLATE_UPDATE = 'QUICK_FILL_TEMPLATE_UPDATE'
export const QUICK_FILL_TEMPLATE_UPDATE_SUBMIT = 'QUICK_FILL_TEMPLATE_UPDATE_SUBMIT'
export const QUICK_FILL_TEMPLATE_UPDATE_FAILURE = 'QUICK_FILL_TEMPLATE_UPDATE_FAILURE'

export const QUICK_FILL_TEMPLATE_DELETE = 'QUICK_FILL_TEMPLATE_DELETE'
export const QUICK_FILL_TEMPLATE_DELETE_SUBMIT = 'QUICK_FILL_TEMPLATE_DELETE_SUBMIT'
export const QUICK_FILL_TEMPLATE_DELETE_FAILURE = 'QUICK_FILL_TEMPLATE_DELETE_FAILURE'

export const QUICK_FILL_TEMPLATE_SORT_SUBMIT = 'QUICK_FILL_TEMPLATE_SORT_SUBMIT'
export const QUICK_FILL_TEMPLATE_SORT = 'QUICK_FILL_TEMPLATE_SORT'
